import { get } from "lodash";
import toast from "react-hot-toast";
import { StorageConstants } from "../constants/AppConstants";
import { ErrorConstants } from "../constants/ErrorConstants";
import Navigation from "../services/NavigationService";
import ObjectStorage from "../modules/ObjectStorage";
import Auth_API from "../services/auth";
import AuthService from "../services/authService";
import { isTokenExpired } from "./isTokenExpired";
let fetchingData = false;
export const checkIsTokenExpired = async () => {
  if (fetchingData) return;
  fetchingData = true;
  const getAccessToken = async (refreshToken) => {
    try {
      const response = await Auth_API.refresh(refreshToken);
      if (response) {
        ObjectStorage.setItem(StorageConstants.ACCESS_TOKEN, {
          token: get(response, "data.accessToken"),
        });
        ObjectStorage.setItem(StorageConstants.MERCHANT_DETAILS, {
          data: { ...get(response, "data.respPayload") },
        });
        fetchingData = false;
        Navigation.navigateToHome();
      }
    } catch (e) {
      console.log("refresh token", e);
      fetchingData = false;
      if (e?.error_code === "ERR_SBEE_0039") {
        AuthService.logout();
        toast.error(e?.detail || ErrorConstants.SOMETHING_WRONG);
      }
    }
  };
  const refreshToken = AuthService._getRefreshToken();
  const accessToken = AuthService._getAccessToken();
  if (!accessToken && !refreshToken) {
    fetchingData = false;
    AuthService.logout();
  }
  if (refreshToken && isTokenExpired(refreshToken)) {
    AuthService.logout();
    Navigation.navigateToHome();
    return;
  }
  if (!accessToken && refreshToken) {
    getAccessToken(refreshToken);
  }
  if (accessToken && refreshToken) {
    const isExpired = isTokenExpired(accessToken);
    if (isExpired) {
      getAccessToken(refreshToken);
    } else {
      fetchingData = false;
    }
  } else if (!accessToken && refreshToken) {
    getAccessToken(refreshToken);
  } else if (!accessToken && !refreshToken) {
    AuthService.logout();
    Navigation.navigateToHome();
  }
};
